export function hasRecentErrorRead(monitor, now) {
  const value = monitor?.coverage?.current?.observedAt ?? monitor?.observedAt;
  const observedAt = typeof value === "number" ? value : typeof value === "string" ? Date.parse(value) : NaN;
  return monitor?.pollingAllowed === true && Number.isFinite(observedAt)
    && observedAt > 0 && now >= observedAt && now - observedAt < 90000;
}
